const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class EngineeringGenius extends Action {
    constructor(age){
        super(
            age,
            ActionNames.EngineeringGenius, 
            `Build one stage of a wonder; pay ${EngineeringGenius.GetResourceAmount(age)} resource less.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 2;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 4;
            case Age.Age3:
                return 5;
        }
    }
}

module.exports = EngineeringGenius;
